import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://github.com/gulsenkeskin"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-github"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/gulsenkeskin/"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-linkedin"></i>
      </a>
      {/* <a
        href="https://registry.jsonresume.org/gulsenkeskin"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-user"></i>
      </a> */}
      <a
        href="https://www.youtube.com/watch?v=TBvpWqhEfVU&t=9s"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-youtube"></i>
      </a>
      <a
        href="https://stackoverflow.com/users/14745090/g%c3%bclsen-keskin_"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-question-circle"></i>
      </a>
      <a
        href="https://dev.to/gulsenkeskin"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-blogger"></i>
      </a>
      <a
        href="https://medium.com/@gulsenkeskin2"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-medium-m"></i>
      </a>
      {/* <a
        href="https://twitter.com/gulsenkeskin_"
        className="home__social-icon"
        target="_blank"
      >
        <i className="uil uil-twitter"></i>
      </a> */}
    </div>
  );
};

export default Social;
